import { useState } from "react";
import { productServices } from "../../api/services/products";

export const useExportFiles = () => {
  const [querySearchExport, setQuerySearchExport] = useState([]);
  const [queryFiltersExport, setQueryFiltersExport] = useState({}); 

  //PDF pagina inicio
  const exportFilePdf = async (queryFilters) => {
    try {
      const queryParams = getQueryString(queryFilters);
      await productServices.exportProductsPDF(queryParams);
    } catch (error) {
    } finally {
    }
  };

  //Excel pagina inicio
  const exportFileExcel = async (queryFilters) => {
    try {
      const queryParams = getQueryString(queryFilters);
      await productServices.exportProductsExcel(queryParams);
    } catch (error) {
    } finally {
    }
  };

  //PDF detalle producto - Historico
  const exportProductFilePdf = async (isin) => {
    try {
      //const queryParams = getQueryString(isin);
      await productServices.exportProductsPDFHistorico(isin);
    } catch (error) {
    } finally {
    }
  };

  //Excel detalle producto - Historico
  const exportProductFileExcel = async (isin) => {
    try {
      //const queryParams = getQueryString(isin);
      await productServices.exportProductsExcelHistorico(isin);
    } catch (error) {
    } finally {
    }
  };

  const getQueryString = (queryFilters) => {
    const params = [];
    const {querySearch,...rest} = queryFilters
    if (querySearch) {
      params.push(`nombre=${encodeURIComponent(querySearch)}`);
    }

    for (const key in rest) {
      if (rest.hasOwnProperty(key)) {
        const value = rest[key];
        if (value) {
          if (key === "tipo") {
            if (value === "fondos") {
              params.push(`tipo=fondos,sicav`);
            } else if (value === "planesindiv") {
              params.push(`tipo=planes&subtipo=planesindiv`);
            } else if (value === "planesasoc") {
              params.push(`tipo=planes&subtipo=planesasoc`);
            } else {
              params.push(
                `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
              );
            }
          } else {
            params.push(
              `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
            );
          }
        }
      }
    }

    return params.join("&");
  };

  return {
    querySearchExport,
    setQuerySearchExport,
    queryFiltersExport,
    setQueryFiltersExport,
    exportFilePdf,
    exportFileExcel,
    exportProductFilePdf,
    exportProductFileExcel,
  };
};
